module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("DURING the next three days Laurie discovered how Vera Manning stayed so youthfully trim. They went horseback riding every morning through the quiet country back roads with Laurie astride a gentle, well-mannered bay gelding named Briar, while Vera rode a spirited chestnut. The weather remained unseasonably warm, so their afternoons were spent in or beside the swimming pool. Being an accomplished swimmer, Laurie thoroughly enjoyed the hours spent at the beautifully designed pool. The aesthetic part of her never ceased admiring the cobblestoned apron with its potted ferns and trees that made the pool so out of the ordinary.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There had been one excursion outside Vera’s estate, a rare trip by car with Vera’s gardener acting as chauffeur. It was a sightseeing tour of Mobile, stopping to tour ante-bellum homes, two of the museums and galleries, a stroll along the Azalea Trail, and a visit to the U.S.S. battleship "), _c('i', [_vm._v("Alabama")]), _vm._v(" permanently docked in Mobile Bay. Despite Laurie’s protests that she didn’t need to be entertained, another outing was planned for next week to Dauphin Island with Judge Hartford and Colin accompanying them for a picnic on the Gulf shore beaches and a walk through old Fort Gaines.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The dinner the night after her arrival had been undemanding fun. Judge Hartford was a tall distinguished man with iron grey hair that was a dignified white at the temples. It had been immediately apparent that he was infatuated with Vera Manning and in part, his affection was returned. Only during the introduction was Rian’s name discussed. Colin had been politely attentive to Laurie, but never overstepped the bounds of friendship.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The subsequent days after the dinner, Colin had found reasons to come over, once to go riding with them in the mornings and twice to swim. His lighthearted banter helped immensely to ease the tension of constantly being on her guard.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Not that Vera was in any way suspicious that Laurie was not what she purported to be. Quite the contrary was true. And the whirlwind of physical activity that Vera Manning indulged in left little time for idle, probing conversations. The introduction of Rian’s name in any conversation was always casual, relating to some preference for food or something equally unimportant. No, Laurie’s concern was that she would accidentally refer to LaRaine’s parents as aunt and uncle or mention that her own were dead. It was more difficult than she would have thought because Vera was the kind of woman she could have confided in. In fact, she invited such confidences by not asking for them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Laurie couldn’t help returning the affection that Vera bestowed upon her so generously. Her own giving nature longed to give it back tenfold, but she had to hold it in check. Realistically Laurie knew that LaRaine would never be a willing party to any long-term correspondence with Vera. Once this visit was over, Vera would probably never see LaRaine, because if she did she would discover the deception immediately, That must be avoided at all costs. So Laurie had to conceal her growing regard for Rian’s aunt. To give her love as freely as she would like would end with Vera being hurt by LaRaine’s failure to maintain the bonds of friendship after her marriage to Rian, and Laurie cared too much already for Vera to have that happen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For the first time in recent years, Laurie found herself being regarded as an individual, not being compared to her vivacious cousin. The total acceptance and admiration, not only from Vera but also from Colin and his father, had a previously unknown sense of self-possession and confidence. It was a new experience that was subtly ego-building, even as she railed against the deception.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This is the end of the fourth day, Laurie told herself as she lay between the white satin sheets of her bed. In another ten days she would be returning to Los Angeles. The bitter taste of guilt reminded her that she would never see these people again. Ten more days of pretending and it would all be over. Her tired muscles silently thanked Vera for being so physically active. Tonight was the first night she hadn’t fallen asleep the instant her head touched the pillow. Laurie turned her head to the side, her black hair spreading over the white pillow like an ebony fan. Her dark lashes closed over her blue, pain-filled eyes in anticipation of the sleep that would soothe and restore her raw nerves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a light rap on the door. Because of the nearly totally white interior of the room, it never seemed completely dark. Laurie sat up to switch on the brass lamp beside the bed as the door swung open and Vera walked in, her eyes glittering with excitement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Were you sleeping?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No,” Laurie shook her head. “Is something wrong?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There’s a phone call for you.” A beaming smile spread across the woman’s face, still looking young and alive without the benefit of make-up. “It’s Rian. You can take it on the extension by your bed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Rian?” Her voice broke as she said his name.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, he’s calling from South America. I’ve already spoken to him, so I’ll leave you to talk to him in private.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Vera waited long enough to see Laurie’s trembling hand pick up the white receiver. Her heart was racing at top speed as she moistened her lips several times before finally saying a stammering “hello” into the phone.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Is that you, LaRaine?” The crisp male voice sounded no further away than the next room.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her hands were clammy with nervous sweat. She was afraid to answer him for fear he would detect the difference between her voice and LaRaine’s. She had no choice, she told herself firmly. She had to bluff it all the way through.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes,” Laurie answered, trying to achieve the purring sound that came so naturally to LaRaine, “I didn’t expect to hear from you, Rian.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I became curious as to how you were getting along with Vera and vice versa.” Yet there seemed to be little curiosity in his voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“She’s an absolute darling.” Laurie seized on LaRaine’s favourite terminology, waiting for the axe to fall on her head.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The gist of Vera’s words was almost exactly the same about you.” Something resembling disbelief came across the wire, mixed with cynicism.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You sound surprised.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Perhaps I can’t quite picture you riding horses and swimming all day,” Rian returned.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Oh, lord, Laurie remembered too late LaRaine’s aversion to swimming. Her own love of water had led her into an unforgivable mistake. “I can put up with anything if it’s only going to be for two weeks,” she said quickly. “Lazing about the pool has improved my tan. I’ll be a golden goddess when you see me again.” She was talking too much. Laurie knew she was talking too much, but she knew no other way.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Vera said you were in bed when I called. Did I wake you?” His swift change of subject surprised her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, yes, you did. I must have just dropped off. I still feel a little groggy. I keep thinking this is a dream,” a nightmare was closer, “and I will wake and discover you didn’t call at all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I guessed you’d been sleeping. Your voice sounds a bit different, like soft velvet.” That was a compliment, but it was delivered with marked indifference as if it were only a passing comment. “I’ll be turning in shortly myself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Are you having a successful trip?” Laurie asked, trying to fill the gap left after his last remark.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, yes, very successful,” he replied dryly. “I suppose I should hang up now so you can get back to your beauty sleep.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You must be tired yourself,” she said nervously.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You sound concerned.” There was arrogant amusement now in the vital masculine voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of course I am.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I almost believe you mean that. Since we both seem to be tired, I’ll say goodnight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, good night, Rian.” Relief tinged her voice with a throaty sound.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Is that all? Just good night?” he mocked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her mind raced, trying to think what LaRaine would say. “There’s more I would like to say, but I’d rather do it in person.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Such as?” he prompted with infuriating calm.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Such as,” forcing a lightness to her Voice that she didn’t feel at all, “I love you and I miss you terribly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a long silence. Laurie felt sure he could hear the pulsating beat of her frightened heart over the telephone.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Those are not the words that will give a man a peaceful night’s sleep when he’s miles away from you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They aren’t meant to,” Laurie replied, inwardly sighing with relief at the answering chuckle on the other end.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Good night, LaRaine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Good night, Rian.” Thankfully the receiver clicked on the other end only seconds after her words of farewell were spoken.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A wave of exultation rippled over her as Laurie silently congratulated herself on fooling Rian Montgomery. An intonation of speech similar to her cousin’s, the excuse of sleep, and the telephone all combined together had made it possible. She hugged the knowledge to herself as she sank back against the pillow. Deceiving Rian Montgomery brought none of the guilt she usually experienced in her masquerade as LaRaine. Now that the fear of discovery had passed, looking back it had almost been fun.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sapphire blue eyes gleamed at the photograph on the bureau. Not even the smouldering contempt outlined by the aquiline features could quell the excitement that held her in its thrall, but it did remind Laurie of the fine line she had just walked. She didn’t want to think of the consequences if he ever did find out. Before the glittering black eyes could steal the thunder of her triumph, Laurie switched off the light, snuggling into the covers with an elated smile still dimpling her cheeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The following morning Judge Hartford and Colin joined Vera and Laurie in a horseback ride over the back roads. Colin was astride his own roan hunter while the Judge expertly controlled the mettlesome grey Arabian that was Rian’s mount when he visited. After the telephone call last night, Laurie was confident she could handle anything. This new poise added a freshness to her appearance, already enhanced by the slim-fitting black slacks and the black and white striped blouse. The folded band of a white silk scarf held her glistening black hair away from her face, cascading it down her back to catch the warm rays of the sun.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The gentle wind had tousled Colin’s golden blond hair as he turned his head to silently admire the girl riding beside him. Laurie tossed him a warm smile, not seeing the answering warmth that leaped into his gaze. She wished they could ride on for ever—that this contentment would remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This is an absolutely glorious morning!” Laurie declared, gazing out over the dew-kissed meadows, vibrantly green backgrounds for the rich browns of the tree trunks. “I wish every day could begin like this.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So do I,” Colin agreed soberly, his eyes drinking in her sparkling beauty. She flashed him another smile, noticing how handsome he looked in his tobacco brown riding pants and the matching jacket over his cream yellow shirt opened at the top to reveal the tanned throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t believe I’ve appreciated how vibrantly beautiful you look, Laurie,” said Judge Hartford, looking back over his shoulder from his position to the front beside Vera. “You make me wish I were Colin’s age again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His teasing comment drew the expected laugh from Laurie. “As handsome as you are, Judge,” she returned gaily, “you would turn any woman’s head regardless of her age.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That may be,” the Judge smiled, “but I wish I knew the secret of your radiance this morning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Laurie was about to credit it to the company she was with when Vera spoke up. “It might have something to do with a certain telephone call last night. Am I right, Laurie?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The expectant look on the older woman’s face forced her to agree. “It had something to do with it,” Laurie admitted, her teeth grating as she uttered the partially true words.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Ah, Rian called,” the Judge nodded sagely while Colin maintained a quiet silence. “That does explain it then. There’s nothing more beautiful than a woman in love, except one who’s on the brink.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Did Rian mention when he would be back?” Colin inserted sharply.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, he only said his trip was successful,” Laurie replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Which means profitable,” Colin murmured with a wry smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I did ask if he would be back in time for Mardi Gras,” Vera commented, bestowing an apologetic smile on Laurie. “But he said he didn’t think so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Mardi Gras starts this week, doesn’t it?” pouncing on the subject like a lifeline.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes,” Colin replied. The relief on his face almost matched Laurie’s. “We must make plans for you to attend some of the parades and at least one of the balls.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I would like that,” Laurie agreed eagerly. “Do you suppose we could, Vera?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Never fear,” the Judge declared with a twinkling smile. “Leave it to me, Laurie. I’ll convince her it would be a major crime for you to miss our most festive season.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Vera laughed, sounding as if she was going to enjoy the charming assault of the distinguished rider as he cajoled her to agree.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Would Rian object?” Colin asked in a lowered voice, slowing his roan so the two older riders could pull ahead.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of course not,” Laurie declared with an airy toss of her head. She didn’t want his name spoiling her day as it was threatening to do. “It was his suggestion,” order was more correct, “that brought me here. I’m sure he must know that Vera will show me around.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I was thinking,” Colin hesitated, “that his objection might be with me. You are his fiancée.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And you’re a friend of the family.” Softening her voice to add, “And my friend, too. I won’t allow him to object. Please, don’t let’s discuss Rian.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("If Colin thought her request was strange, he didn’t comment, but conceded easily to her wishes with a brief description of the Mardi Gras activities over the next week. Gradually the subject shifted to the man and woman riding several yards ahead of them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You coming here has been a good thing for Vera,” Colin stated. “Especially if the Judge persuades her to attend a ball, which I have no doubt he will, because of you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Why do you say that? I haven’t noticed anything wrong with Vera.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“These past years she’s become somewhat of a recluse, using her abhorrence of cars, planes, and crowds to stay at home. She’s let her membership lapse in many of the clubs she belonged to, and only her closest friends have stayed in touch,” he explained.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Vera is so warm and outgoing, that’s hard to believe,” Laurie murmured. “She’s always so active, constantly doing things.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But never becoming involved in anything except Rian.” A corner of his mouth quirked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Laurie let the name pass. “Vera never discusses her husband. Is he the reason?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes,” Colin nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, go on. Tell me what happened. Does it have something to do with his death? Vera did say he died some years ago,” Laurie prompted.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“From what the Judge has told me of the early days, it must have started long before that,” Colin said, slowing his mount so there would be more distance between the riders in front of them. “Charles Manning was from a good family who like a lot of others lost their money during the Depression. But Charles was a very charming opportunist. As lovely as Vera is now, she was that much more beautiful as a young woman. The Judge was in love with her even then. If Charles hadn’t come along, I’m sure he would have married her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But she married Charles Manning,” Laurie sighed, remembering how she had guessed the first time she had seen the Judge with Vera that he was in love with her. Her heart went out to the distinguished grey-haired man riding so erectly in front of her, his brown eyes never wavering too long from Vera’s face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“She eloped with Charles Manning,” Colin corrected bleakly. “You see, Ian Montgomery, Vera’s father and Rian’s grandfather, saw through Manning’s guise of adoration for his daughter as a means to the family fortune and refused to let Vera see him. I’ve often wondered if he hadn’t been so dictatorial whether Vera would have seen what kind of man Charles was. As matter of fact, I’ve always thought that Ian Montgomery could have bought him off, but he wasn’t man to be blackmailed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What happened after they eloped? Did her father disinherit her?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, Ian was a man with a great sense of family loyalty, and in his old-fashioned way of thinking, Vera was a beautiful woman without the sense to realize what a mistake she’d made. Once the damage had been done and the marriage was a reality, Ian tried to put Charles to work in the family business. From what I understand the first few years of their marriage, Charles made a concerted effort to be the family man and business executive he was expected to be. But my father says he was a born philanderer. Before anybody realized what was happening he was having an affair with his secretary. Vera always took the blame for his straying because she couldn’t have children. She turned a blind eye to every new mistress and the rest of the family had no choice but to do the same.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Poor Vera!” The lump in her throat was hard to swallow. Such a life would have broken the spirit of a lesser woman.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Everyone turned a blind eye except Rian,” Colin continued. “I told you that after his parents were killed, he went to live with Vera and Charles who were staying here in Ian Montgomery’s house. Rian was fourteen or fifteen at the time. Yet he never attempted to hide his loathing and contempt for Charles Manning. He never understood Vera’s constant assertions that she loved Charles despite his less than perfect ways. He must have been a terrible thorn in Charles’s side, always taunting him about his mistresses, never caring who was there, even Vera.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That must have made it difficult for everyone,” Laurie commented, while partially admiring Rian for daring to bring things out in the open.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“If Ian hadn’t died, it’s hard to say how long Charles would have continued with his discreet affairs. Rian was twenty-five at the time, a young age to be handed the reins of a sprawling conglomerate. Perhaps it was the absence of Rian and the death of his grandfather that made Charles so reckless. He began appearing at public places with his women and no longer attempted to pretend his marriage to Vera was sailing along smoothly. In fact he was rarely home, and usually only when Rian was expected.” Colin paused, staring off into the quiet countryside before bringing his grim gaze back to Laurie. “One day, a few months after Ian’s death, Vera met Rian for lunch. They went to one of the more exclusive restaurants in town, only to find Charles at one of the secluded tables with a young blonde. Vera would have walked on past without acknowledging his presence, but Rian walked right up to the table and grabbed Charles by the collar. Rian damned near beat him to death before they were able to drag him away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Laurie’s gasp of surprise brought a sympathetic glance from Colin.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The intervention of the Judge, Charles’s failure to press charges, and the power of the Montgomery name kept it out of the papers, but the tongues of the gossips had a field day with it. Vera filed for separation papers, although her religious principles wouldn’t allow her to divorce Charles. She rarely ventured out of the house for two years. Then, when she was beginning to take part in some of the social activities again, Charles was killed in a car crash in the company of a married woman. And the whole scandal was revived again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No wonder she never discussed any of this with me. It’s a pity that the past can’t truly be buried,” Laurie sighed. “Vera is too loving a woman to have to carry that burden the rest of her life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My father agrees with you,” Colin smiled. “And he’s a patient and persistent man.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You would really like to see them get married, wouldn’t you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t remember my own mother. She died when I was two. Vera is the only maternal figure I’ve known.” His gold-flecked eyes glanced at the youthfully trim woman riding beside his father. “Besides, I’m a sucker for a happy ending. And the Judge has been in love with her too many years for me not to want to see that love fulfilled.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I think perhaps Vera is afraid to fall in love again,” Laurie commented.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I think she was more afraid that Rian wouldn’t marry.” A frown creased Colin’s otherwise unlined forehead. “The Judge believes that once you and Rian are safely married Vera might be more susceptible to his persuasions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do you think so?” A whimsical expression played over her face as for the first time Laurie hoped that Rian and LaRaine’s marriage would take place soon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“To tell the truth, when I first heard Rian was engaged, I thought he might be doing it to please Vera and to have children to carry on the family name. You must remember,” Colin said with a half-smile. “I hadn’t met you yet and I couldn’t picture Rian marrying for love. Now I can’t see how anyone could help falling in love with you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The need to dim the ardent glow in his eyes brought an instant protest from Laurie. “Colin, please, I—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Don’t say it,” he interrupted swiftly, a bitter curl to his mouth. “I know you’re in love with Rian and are going to marry him. I admit I’m half infatuated with you already, but it will go no farther. Friends it will be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Even if she wanted it to be more, like Colin she would have to be satisfied with a brief friendship.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Shall we catch up with Vera and your father?” she suggested.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Colin nodded, nudging his roan into a canter, and Laurie followed suit.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e63ad42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/section7.vue
// module id = 90
// module chunks = 0